module.exports = __webpack_public_path__ + "img/6-1.41a2b8df.jpg";